import toastr from 'toastr'
import layout from 'layouts/default'
import env from 'constants/env'
import { permits, user } from 'services'

const components = {
  layout
}

const computed = {
  allowed () {
    return permits.hasPermit('super_admin')
  },
  baseUrl () {
    return env.default.parkingOtaUrl
  }
}

const methods = {
  loadScript () {
    if (window.ResLabAffiliate) {
      this.initWidget()
      return
    }

    const script = document.createElement('script')
    script.src = this.baseUrl + '/assets/js/ResLabAffiliate.js'
    script.onload = () => this.initWidget()
    script.onerror = () => toastr.error('Failed to load ResLabAffiliate.js')
    document.head.appendChild(script)
  },

  initWidget () {
    window.ResLabAffiliate.init({ apiBaseUrl: this.baseUrl, allowedOrigins: [this.baseUrl] })
    this.scriptLoaded = true
  },

  async loadIframe () {
    const iframe = await window.ResLabAffiliate.loadResLabParkingIframe({
      containerId: 'reslabIframe',
      channelId: Number(this.form.channelId) || 31,
      airportCode: this.form.airportCode.trim() || 'ATL',
      fromDate: this.form.fromDate.trim(),
      toDate: this.form.toDate.trim(),
      userEmail: this.form.userEmail.trim(),
      userName: this.form.userName.trim(),
      phoneNumber: this.form.phoneNumber.trim(),
      callbacks: {
        onReady: (data) => console.log('Iframe Ready Callback:', data),
        onBookingSelected: (data) => console.log('Booking Selected Callback:', data),
        onBookingDeleted: (data) => console.log('Booking Deleted Callback:', data)
      }
    })

    if (!iframe) {
      toastr.error('Missing required parking parameters')
    }
  },

  removeIframe () {
    window.ResLabAffiliate.removeIframe('reslabIframe')
  }
}

export default {
  name: 'parkingOta',
  components,
  computed,
  methods,
  data () {
    return {
      scriptLoaded: false,
      form: {
        channelId: 41,
        airportCode: 'ATL',
        fromDate: '2026-10-20 15:00:00',
        toDate: '2026-10-25 15:00:00',
        userEmail: 'john.doe@example.com',
        userName: 'John Doe',
        phoneNumber: '(404) 555-0123'
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!isServer && user.getToken() && user.hasFrontAccess() && !permits.hasPermit('super_admin')) {
      next({ name: 'home' })
      return
    }
    next()
  },
  mounted () {
    if (this.allowed) {
      this.loadScript()
    }
  },
  beforeDestroy () {
    if (this.scriptLoaded) {
      this.removeIframe()
    }
  }
}
